const FRENCH_DISCOUNT = 0.90;

export function calculateIngredientCO2(ingredient) {
  if (!ingredient) return 0;

  const meal = ingredient.CarbonFootprintIngredientMeal;
  const quantity = meal?.ingredient_quantity || 0;
  const unit = meal?.ingredient_unit;
  const climateChange = ingredient.climate_change || 0;

  if (!quantity || !climateChange) return 0;

  const quantityInKg = unit === 'g' ? quantity / 1000 : quantity;
  const adjustedClimateChange = ingredient.country === 'France'
    ? climateChange * FRENCH_DISCOUNT
    : climateChange;

  return quantityInKg * adjustedClimateChange;
}

export function calculateMealCO2PerServing(ingredients, servings) {
  if (!ingredients || ingredients.length === 0) return 0;

  const totalCO2 = ingredients.reduce(
    (acc, ingredient) => acc + calculateIngredientCO2(ingredient),
    0
  );

  const effectiveServings = servings || 1;
  return totalCO2 / effectiveServings;
}
